import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';

const RenderPolygons3D = (props) => {
  useEffect(() => {
    if (!props.mapReferenceThreed || typeof props.mapReferenceThreed.append !== 'function') {
      console.warn("Invalid mapReferenceThreed:", props.mapReferenceThreed);
      return;
    }

    if (props.mapReferenceThreed) {
      mapFunction();
    }
  }, [props.mapReferenceThreed, props.polygons]);

  async function mapFunction() {
    const { Polygon3DElement, Map3DElement } = await window.google.maps.importLibrary("maps3d");
    props?.polygons?.forEach(polygon => {

      const geoJson = polygon?.geoJson && JSON.parse(polygon.geoJson);
      const coordinates = geoJson?.features[0]?.geometry?.coordinates[0]?.map(coord => ({
        lat: coord[1],
        lng: coord[0],
        altitude: 2000 // Default extrusion height
      }));

      const polygonOptions = {
        strokeColor: geoJson?.features[0]?.properties?.line?.color + '80' || "#EA433580",
        strokeWidth: 5,
        fillColor: geoJson?.features[0]?.properties?.line?.fill + '20' || "#EA433520",
        // altitudeMode: "ABSOLUTE",  // Must be ABSOLUTE for wall effect
        altitudeMode: "CLAMP_TO_GROUND",//"RELATIVE", //"CLAMP_TO_GROUND",// "ABSOLUTE", // or "CLAMP_TO_GROUND" / "RELATIVE"
        extruded: true,
        drawsOccludedSegments: true,
      }

      const towerPolygon = new google.maps.maps3d.Polygon3DElement(polygonOptions);
      towerPolygon.outerCoordinates = coordinates
      props.mapReferenceThreed.append(towerPolygon);
    });
  }

  return null;
};

const mapStateToProps = state => ({
  polygons: state.polygons,

});

export default connect(mapStateToProps)(RenderPolygons3D);